// @ngInject
function labelPrintingDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(order) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'labelPrintingDialogController as vm',
            templateUrl: 'services/dialogs/labelPrintingDialog/labelPrintingDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            order: function() {
                return order;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function labelPrintingDialogController($uibModalInstance, order, loadSpinnerService, OrdersApiService, $translate, ToasterService) {
    var vm = this;

    //Properties
    vm.order = order;

    //Methods
    vm.closeModal = closeModal;
    vm.printOrderLabels = printOrderLabels;

    activate();

    function activate() {
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.getDeliveryDates(vm.order.id).then(function(response) {
            vm.selectableDates = [];
            _.forEach(response.data.deliveryDates, function(entry) {
                var dateObj = new Date(entry.startDate);

                entry.id = entry.startDate;
                entry.description = $translate.instant("order.printlabel.deliveredto") + ' ' + getDeliveryDateString(dateObj);

                //if user wants to print labels for whole date
                var useWholeDate = (dateObj.getHours() === 0 && dateObj.getMinutes() === 0);

                vm.selectableDates.push({
                    id: entry.id,
                    description: entry.description,
                    useWholeDate: useWholeDate
                });
            });

            vm.selectableDates.unshift({ id: "allDates", description:$translate.instant("order.printlabel.ordered")});

            if (vm.selectableDates.length !== 0) {
                vm.selectedDate = vm.selectableDates[0];
            }
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getDeliveryDateString(date) {
        if (!date) { return ''; }

        var dateStr = date.getFullYear() + '-' + zeroFill(date.getMonth() + 1, 2) + '-' + zeroFill(date.getDate(), 2) + ' ' + zeroFill(date.getHours(), 2) + ':' + zeroFill(date.getMinutes(), 2);
        if (date.getHours() === 0 && date.getMinutes() === 0) {
            dateStr = date.getFullYear() + '-' + zeroFill(date.getMonth() + 1, 2) + '-' + zeroFill(date.getDate(), 2);
        }

        return dateStr;
    }
    function zeroFill(number, width)
    {
        width -= number.toString().length;
        if (width > 0)
        {
            return new Array(width + ((/\./).test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ''; // always return a string
    }

    function printOrderLabels() {
        if (vm.selectedDate.id !== "allDates") {
            loadSpinnerService.start('mainSpinner');
            var request = {
                orderId: vm.order.id,
                orderNumber: vm.order.orderNumber,
                date: vm.selectedDate.id,
                useWholeDate: vm.selectedDate.useWholeDate
            };
            OrdersApiService.downloadLabelsForDate(request).then(function(response) {
                $uibModalInstance.close(true);
            }, function(error) {
                ToasterService.showError(error.message);
            }).finally(function() {
                loadSpinnerService.stop('mainSpinner');
            });
        } else {
            loadSpinnerService.start('mainSpinner');
            OrdersApiService.downloadLabels(vm.order.id, vm.order.orderNumber).then(function(response) {
                $uibModalInstance.close(true);
            }, function(error) {
                ToasterService.showError(error.message);
            }).finally(function() {
                loadSpinnerService.stop('mainSpinner');
            });
        }
    }

    function closeModal(isCompleted) {
        $uibModalInstance.close(isCompleted);
    }
}

angular
    .module('services.dialogs.labelPrintingDialog', [])
    .service('labelPrintingDialogService', labelPrintingDialogService)
    .controller('labelPrintingDialogController', labelPrintingDialogController);
